import { gql } from "graphql-tag"

const typeConfiguration = gql`
  type Query {
    configuration(lang: String, cdn: Boolean = true): JSONObject!
  }
`

export { typeConfiguration }

export default typeConfiguration
